module.exports = __webpack_public_path__ + "img/logo_pinx_color.b3cbe86e.png";